import { BoxIcon, Button } from '#atoms';

import { useEffect, useState } from 'react';
import { useToast } from '#providers/ToastProvider';
import {
  ClinicalDataProps,
  FilterOptionProps,
  optionProps
} from '#pages/ClinicalDataList';
import { useFilter } from './Filter';
import {
  ButtonBox,
  Container,
  Content,
  FliterBox,
  FliterLabel,
  Header,
  OptionBox,
  OptionLabel
} from './styles';

interface ClinicalFilterSheetProps {
  filterOption: FilterOptionProps;
  isOpenFilter: boolean;
  clickHandlerFilter: ({
    option1,
    option2,
    option3,
    option4
  }: optionProps) => void;
  onClose: () => void;
  data: ClinicalDataProps[];
}

export const ClinicalFilterSheet = ({
  filterOption,
  isOpenFilter,
  clickHandlerFilter,
  onClose,
  data
}: ClinicalFilterSheetProps) => {
  const [filter1, setFilter1] = useState(filterOption.round);
  const [filter2, setFilter2] = useState(filterOption.lectureName);
  const [filter3, setFilter3] = useState(filterOption.sex);
  const [filter4, setFilter4] = useState(filterOption.age);

  const [filterData, setFilterData] = useState(data);

  const { showToast } = useToast();
  const option1 = {
    Label: '운동 횟수',
    option: ['전체', '10회 이상', '20회 이상', '30회 이상']
  };

  const option2 = {
    Label: '운동 목적',
    option: ['전체', '다이어트', '체형교정', '재활운동', '바디프로필']
  };

  const option3 = {
    Label: '회원 성별',
    option: ['전체', '남성', '여성']
  };

  const option4 = {
    Label: '회원 연령대',
    option: ['전체', '20대 이하', '30대', '40대', '50대 이상']
  };

  const onSetdata = () => {
    clickHandlerFilter({
      option1: filter1,
      option2: filter2,
      option3: filter3,
      option4: filter4
    });
    onClose();
  };

  useEffect(() => {
    setFilterData(
      useFilter({
        dummyData: data,
        filterOption: {
          round: filter1,
          lectureName: filter2,
          sex: filter3,
          age: filter4
        }
      })
    );
  }, [filter1, filter2, filter3, filter4]);

  useEffect(() => {
    showToast({
      type: 'fail',
      message:
        '검색된 임상 데이터가 없어요.더 많은 결과를 보려면 필터 일부를 해제해보세요.'
    });
  }, []);

  const reset = () => {
    setFilter1(0);
    setFilter2(0);
    setFilter3(0);
    setFilter4(0);
  };
  return (
    <Container isOpenFilter={isOpenFilter}>
      <Header isOpenFilter={isOpenFilter}>
        <BoxIcon
          type="prev-arrow"
          width={24}
          height={24}
          boxColor="transparent"
          onClick={() => {
            setFilter1(filterOption.round);
            setFilter2(filterOption.lectureName);
            setFilter3(filterOption.sex);
            setFilter4(filterOption.age);
            onClose();
          }}
        />
        <div className="title">필터</div>
        <div className="right"></div>
      </Header>
      <Content>
        <FliterBox>
          <FliterLabel>{option1.Label}</FliterLabel>
          {option1.option.map((item, index) => (
            <OptionBox key={index} onClick={() => setFilter1(index)}>
              <OptionLabel>{item}</OptionLabel>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <rect
                  width="18"
                  height="18"
                  fill={filter1 === index ? '#7750E9' : '#383441'}
                  rx="4"
                  ry="4"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
                  fill="white"
                />
              </svg>
            </OptionBox>
          ))}
        </FliterBox>
        <FliterBox>
          <FliterLabel>{option2.Label}</FliterLabel>
          {option2.option.map((item, index) => (
            <OptionBox key={index} onClick={() => setFilter2(index)}>
              <OptionLabel>{item}</OptionLabel>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <rect
                  width="18"
                  height="18"
                  fill={filter2 === index ? '#7750E9' : '#383441'}
                  rx="4"
                  ry="4"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
                  fill="white"
                />
              </svg>
            </OptionBox>
          ))}
        </FliterBox>
        <FliterBox>
          <FliterLabel>{option3.Label}</FliterLabel>
          {option3.option.map((item, index) => (
            <OptionBox key={index} onClick={() => setFilter3(index)}>
              <OptionLabel>{item}</OptionLabel>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <rect
                  width="18"
                  height="18"
                  fill={filter3 === index ? '#7750E9' : '#383441'}
                  rx="4"
                  ry="4"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
                  fill="white"
                />
              </svg>
            </OptionBox>
          ))}
        </FliterBox>
        <FliterBox>
          <FliterLabel>{option4.Label}</FliterLabel>
          {option4.option.map((item, index) => (
            <OptionBox key={index} onClick={() => setFilter4(index)}>
              <OptionLabel>{item}</OptionLabel>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <rect
                  width="18"
                  height="18"
                  fill={filter4 === index ? '#7750E9' : '#383441'}
                  rx="4"
                  ry="4"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
                  fill="white"
                />
              </svg>
            </OptionBox>
          ))}
        </FliterBox>
      </Content>
      <ButtonBox isOpenFilter={isOpenFilter}>
        <Button background="anti" onClick={reset}>
          초기화
        </Button>
        <Button onClick={onSetdata} disabled={filterData.length < 1}>
          {filterData.length}개의 데이터보기
        </Button>
      </ButtonBox>
    </Container>
  );
};
